import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import ActionMenuListTitle from './ActionMenuListTitle';

interface IActionMenuListProps {
  title?: string;
  listType?: 'child' | 'parent';
  tabIndex?: number;
  children?: React.ReactNode;
  className?: string;
}

const Layout = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  max-height: 100%;
  padding: ${toRem(theme.space.md)};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};

  &:focus {
    outline: none;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const List = styled.ul<IActionMenuListProps>`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;

  ${({ listType }) =>
    listType === 'child' &&
    css`
      overflow-x: hidden;
      overflow-y: auto;
    `}
`;

const ActionMenuList: React.FC<IActionMenuListProps> = ({ title, listType = 'parent', tabIndex, children, className }) => (
  <Layout className={className}>
    {title && <ActionMenuListTitle>{title}</ActionMenuListTitle>}
    <List listType={listType} tabIndex={tabIndex}>
      {children}
    </List>
  </Layout>
);

export default ActionMenuList;
